export const pageRoutes = {
  overview: '/dashboard',
  callinbox: '/call-inbox',
  calls: '/caller-console',
  callreports: '/incoming-calls-report',
  leads: '/leads',
  guestbook: '/todays-reservations',
  analytics: '/upcoming-reservations',
  bookings: '/all-reservations',
  customerbook: '/guest-book',
  revenue: '/branch-analytics',
  slotsummary: '/slot-summary',
  slotmanagement: '/slot-management',
  slottimings: '/slot-timings',
  heatmap: '/slot-analytics',
  advances: '/accounts/advance-payments',
  refunds: '/accounts/refunds',
  reportadvance: '/reports/advance-payments',
  reportcovers: '/reports/covers',
  reportreconciliation: '/reports/slot-cover-reconciliation',
  reportinsight: '/reports/reservation-insight',
  reportfeedback: '/reports/customer-feedback',
  teammonitor: '/management/team-monitor'
};

export const routePages = Object.fromEntries(
  Object.entries(pageRoutes).map(([pageId, route]) => [route, pageId])
);

export function pageIdForPath(pathname = '') {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (normalized === '/' || normalized === '/app' || normalized === '/index.html') return 'overview';
  return routePages[normalized] || '';
}

export function pathForPageId(pageId = '') {
  return pageRoutes[pageId] || '/dashboard';
}

export function isAppRoute(pathname = '') {
  return Boolean(pageIdForPath(pathname));
}
